import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-create-user',
    templateUrl: './create-user.component.html',
    styleUrls: ['./create-user.component.scss'],
    standalone: false
})
export class CreateUserComponent {

	@Output() userChanged: EventEmitter<any> = new EventEmitter();

	@ViewChild('createUser') createUserModal!: TemplateRef<any>;
	@ViewChild('changeStatusUser') changeStatusUserModal!: TemplateRef<any>;
	@ViewChild('reInviteUser') reInviteUserModal!: TemplateRef<any>;
	@ViewChild('successModal') successModal!: TemplateRef<any>;
	@ViewChild('errorModal') errorModal!: TemplateRef<any>;

	createUserModalRef: any;
	createForm!: UntypedFormGroup;
	submitted = false;
	selectedRoles: string[] = [];

	roles: any[] = [];

	client_roles: any[] = [
		{ code: 'ADMIN', name: 'Account Admin' },
		{ code: 'ANALYST', name: 'Analyst' },
		{ code: 'EDITOR', name: 'Editor' },
		{ code: 'OWNER', name: 'Project Owner' }
	];

	administration_roles: any[] = [
		{ code: 'ADMIN', name: 'Account Admin' },
		{ code: 'ANALYST', name: 'Analyst' },
		{ code: 'COMPLIANCE', name: 'Compliance Officer' },
		{ code: 'REGULATOR', name: 'Global Regulator' }
	];

	state_mode = '';
	title = '';
	selectedUser!: any | null;
	current_client!: any | null;
	spinner = false;
	successMessage = '';
	success = false;
	status = 'added';
	button_text = 'Create';

	constructor(private modalService: NgbModal, private router: Router, private formBuilder: UntypedFormBuilder, private userService: UserService, private authService: AuthService) {}

	get f() { return this.createForm.controls; }

	openModal(state: string, user?: any) {
		this.current_client = this.authService.currentClientValue;

		if (this.current_client.client_id === 0) {
			this.roles = this.administration_roles;
		} else {
			this.roles = [...this.client_roles];

			if (this.current_client.client_id === 1) {
				this.roles.push({ code: "RESTRICTED", name: "Restricted Areas" });
			}
		}

		this.submitted = false;
		this.spinner = false;
		this.success = false;
		this.state_mode = state;
		
		switch (state) {
			case 'create':
				this.createForm = this.formBuilder.group({
					email: ['', [Validators.required, Validators.email]]
				});
	
				this.title = 'Invite New User';
				this.status = 'added';
				this.button_text = 'Create';
				break;
			case 'invite':
				this.title = 'ReInvite User';
				this.status = 'reinvite';
				this.button_text = 'Invite';
				
				if (user) {
					this.selectedUser = user;
					this.selectedRoles = user.roles;
		
				} else {
					this.authService.toastErrorMessage('User Not found', '')
				}
				break;
			case 'edit':
				this.title = 'Update User';
				this.status = 'updated';
				this.button_text = 'Update';
				
				if (user) {
					this.selectedUser = user;
					this.selectedRoles = user.roles;
		
					this.createForm = this.formBuilder.group({
						email: [{ value: this.selectedUser.user.email, disabled: true }, [Validators.required, Validators.email]]
					});
		
				} else {
					this.authService.toastErrorMessage('User Not found', '')
				}
				break;
			case 'remove':
				this.title = 'Remove User';
				this.status = 'removed';
				this.button_text = 'Remove';
				
				if (user) {
					this.selectedUser = user;
					this.selectedRoles = user.roles;		
				} else {
					this.authService.toastErrorMessage('User Not found', '')
				}
				break;
			case 'suspend':
				this.title = 'Suspend User';
				this.status = 'suspended';
				this.button_text = 'Suspend';
				
				if (user) {
					this.selectedUser = user;
					this.selectedRoles = user.roles;		
				} else {
					this.authService.toastErrorMessage('User Not found', '')
				}
				break;
			case 'activate':
				this.title = 'Activate User';
				this.status = 'activated';
				this.button_text = 'Activate';
				
				if (user) {
					this.selectedUser = user;
					this.selectedRoles = user.roles;		
				} else {
					this.authService.toastErrorMessage('User Not found', '')
				}
				break;
		}

		const createOrError = this.current_client.client_id === 0 ? true : this.current_client.plan ? true : false;

		if (state === 'create' || state === 'edit') {
			this.createUserModalRef = this.modalService.open(createOrError ? this.createUserModal : this.errorModal, { size: 'l', backdrop: 'static', keyboard : false });
		} else if (state === 'invite') {
			this.createUserModalRef = this.modalService.open(createOrError ? this.reInviteUserModal : this.errorModal, { size: 'l', backdrop: 'static', keyboard : false });
		} else {
			this.createUserModalRef = this.modalService.open(createOrError ? this.changeStatusUserModal : this.errorModal, { size: 'l', backdrop: 'static', keyboard : false });
		}
  }

	reinvite() {
		this.submitted = true;
		this.spinner = true;
		
		this.userService.reinviteNewUser(this.selectedUser.id).subscribe({
			next: (data) => {
				if(data.exist) {
					this.submitted = false;
					this.spinner = false;
					this.authService.toastErrorMessage(data.message, 'Invite User Error!');
				} else {
					this.successMessage = data.message;
					this.submitted = false;
					this.spinner = false;
					this.createUserModalRef.close();
					this.success = true;
					this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
				}
			},
			error: (err) => {
				this.submitted = false;
				this.spinner = false;
				this.authService.toastErrorMessage(err, 'Invite User Error!');
				this.closeModal();
			}
		});
	}

	onSubmit() {
		this.submitted = true;
		this.spinner = true;

		if (this.createForm ) {
			if (this.createForm.invalid) {
				this.spinner = false;
				return;
			}
		}

		if (this.selectedRoles.length === 0) {
			this.spinner = false;
			return;
		}

		switch (this.state_mode) {
			case 'create':
				this.createForm.value.roles = this.selectedRoles;
				this.userService.inviteNewUser(this.createForm.value).subscribe({
					next: (data) => {
						if(data.exist) {
							this.submitted = false;
							this.spinner = false;
							if (data.removed) {
								this.createUserModalRef.close();
								this.selectedUser = data.client_user;
								const createOrError = this.current_client.client_id === 0 ? true : this.current_client.plan ? true : false;
								this.createUserModalRef = this.modalService.open(createOrError ? this.reInviteUserModal : this.errorModal, { size: 'l', backdrop: 'static', keyboard : false });
							} else {
								this.authService.toastErrorMessage(data.message, 'Invite User Error!');
							}
						} else {
							this.successMessage = data.message;
							this.submitted = false;
							this.spinner = false;
							this.createUserModalRef.close();
							this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
							this.success = true;
						}
					},
					error: (err) => {
						this.submitted = false;
						this.spinner = false;
						this.authService.toastErrorMessage(err.message ? err.message : err , 'Invite User Error!');
					}
				});
				break;
			case 'invite':
				this.userService.reinviteNewUser(this.selectedUser.id).subscribe({
					next: (data) => {
						if(data.exist) {
							this.submitted = false;
							this.spinner = false;
							this.authService.toastErrorMessage(data.message, 'Invite User Error!');
						} else {
							this.successMessage = data.message;
							this.submitted = false;
							this.spinner = false;
							this.createUserModalRef.close();
							this.success = true;
							this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
						}
					},
					error: (err) => {
						this.submitted = false;
						this.spinner = false;
						this.authService.toastErrorMessage(err, 'Invite User Error!');
						this.closeModal();
					}
				});
				break;
			case 'edit':
				this.userService.updateClientUserRoles(this.selectedUser.id, { roles: this.selectedRoles }).subscribe({
					next: (data) => {
						if(data.exist) {
							this.submitted = false;
							this.spinner = false;
							this.authService.toastErrorMessage(data.message, 'Invite User Error!');
						} else {
							this.successMessage = data.message;
							this.submitted = false;
							this.spinner = false;
							this.createUserModalRef.close();
							this.success = true;
							this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
						}
					},
					error: (err) => {
						this.submitted = false;
						this.spinner = false;
						this.authService.toastErrorMessage(err, 'Invite User Error!');
						this.closeModal();
					}
				});
				break;
			case 'remove':
				this.userService.updateClientUserStatus(this.selectedUser.id, { status: 'REMOVED' }).subscribe({
					next: (data) => {
						if(data.exist) {
							this.submitted = false;
							this.spinner = false;
							this.authService.toastErrorMessage(data.message, 'Update User Error!');
						} else {
							this.successMessage = data.message;
							this.submitted = false;
							this.spinner = false;
							this.createUserModalRef.close();
							this.success = true;
							this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
						}
					},
					error: (err) => {
						this.submitted = false;
						this.spinner = false;
						this.authService.toastErrorMessage(err, 'Update User Error!');
						this.closeModal();
					}
				});
				break;
			case 'suspend':
				this.userService.updateClientUserStatus(this.selectedUser.id, { status: 'SUSPENDED' }).subscribe({
					next: (data) => {
						if(data.exist) {
							this.submitted = false;
							this.spinner = false;
							this.authService.toastErrorMessage(data.message, 'Update User Error!');
						} else {
							this.successMessage = data.message;
							this.submitted = false;
							this.spinner = false;
							this.createUserModalRef.close();
							this.success = true;
							this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
						}
					},
					error: (err) => {
						this.submitted = false;
						this.spinner = false;
						this.authService.toastErrorMessage(err, 'Update User Error!');
						this.closeModal();
					}
				});
				break;
			case 'activate':
				this.userService.updateClientUserStatus(this.selectedUser.id, { status: 'ACTIVE' }).subscribe({
					next: (data) => {
						if(data.exist) {
							this.submitted = false;
							this.spinner = false;
							this.authService.toastErrorMessage(data.message, 'Update User Error!');
						} else {
							this.successMessage = data.message;
							this.submitted = false;
							this.spinner = false;
							this.createUserModalRef.close();
							this.success = true;
							this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
						}
					},
					error: (err) => {
						this.submitted = false;
						this.spinner = false;
						this.authService.toastErrorMessage(err, 'Update User Error!');
						this.closeModal();
					}
				});
				break;
		}
	}

	closeModal() {
		if (this.current_client.plan || this.current_client.client_id === 0) {
			if (this.router.url.includes('users')) {
				if (this.success) {
					this.userChanged.emit();
				}
			}
	
			this.selectedRoles = [];
			this.selectedUser = null;
			if (this.createForm) {
				this.createForm.reset();
			}
			this.modalService.dismissAll();
		} else {
			this.modalService.dismissAll();
		}
	}
}
